module.exports = __webpack_public_path__ + "img/icon-line-bot.b3d275a2.svg";